import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import useAxios from 'axios-hooks';

import TurbineInfoModal from 'components/dashboard/TurbineInfoModal';
import { getLiveParams } from 'selectors/liveParams';

const TurbineInfoModalContainer = ({ windTurbine, errorText, ...props }) => {
  const windTurbineId = windTurbine && windTurbine.id;

  const [{ loading }, sendErrorEmail] = useAxios(
    {
      url: `/windTurbines/${windTurbineId}/sendErrorEmail`,
      method: 'POST',
    },
    { manual: true }
  );

  const [{ loading: savingEmail }, updateEmail] = useAxios(
    {
      url: `/windTurbines/${windTurbineId}/email`,
      method: 'PUT',
    },
    { manual: true }
  );

  const onSendEmail = async () => {
    try {
      await sendErrorEmail({ data: { errorText } });
      toast.success('Email trimis cu succes');
      return true;
    } catch (e) {
      toast.error((e.response && e.response.data && e.response.data.error) || 'Trimiterea emailului a eșuat');
      return false;
    }
  };

  // The turbine object shown here comes from the parent page, not from
  // this modal - a successful save doesn't refresh it, so windTurbine.email
  // (and the input bound to it) still shows the old value until the parent
  // reloads the turbine. Good enough for now; the toast is the confirmation.
  const onSaveEmail = async (email) => {
    try {
      await updateEmail({ data: { email } });
      toast.success('Email actualizat cu succes');
    } catch (e) {
      toast.error((e.response && e.response.data && e.response.data.error) || 'Salvarea emailului a eșuat');
    }
  };

  return (
    <TurbineInfoModal
      {...props}
      windTurbine={windTurbine}
      errorText={errorText}
      onSendEmail={onSendEmail}
      onSaveEmail={onSaveEmail}
      sending={loading}
      savingEmail={savingEmail}
    />
  );
};

// windTurbine can be momentarily undefined during navigation between two
// turbines' detail pages - see components/dashboard/CardHeader.js's guard
// for the crash this caused. mapStateToProps runs on every store update.
const mapStateToProps = (state, ownProps) => {
  const windTurbineId = ownProps.windTurbine && ownProps.windTurbine.id;
  const { err } = getLiveParams(state, windTurbineId, ['err']);
  return {
    errorText: err,
  };
};

export default connect(mapStateToProps)(TurbineInfoModalContainer);
